import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import svgJar from 'ember-svg-jar/helpers/svg-jar';

import modelIcon from 'umg-ember-backend/helpers/model-icon';
import { getBem } from 'umg-ember-backend/utils/get-bem';
import { lookupTranslation } from 'umg-ember-backend/utils/intl';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class PageBuilderContentItemsSelectItemComponent extends Component {
  // Services
  @service intl;

  // Getter and setter
  get existingContentItem() {
    let siblings = this.args.siblings;
    let contentItemType = this.args.contentItemType;
    let existingContentItem = siblings.find(
      (sibling) => sibling.type === contentItemType,
    );

    return existingContentItem;
  }

  get contentItemTypeName() {
    const contentItemType = this.args.contentItemType;
    const lookups = [
      `page_builder.content_items.select.item.${contentItemType}`,
      `models.${contentItemType}`,
    ];

    return lookupTranslation.call(this, lookups);
  }

  // Template
  <template>
    <button
      class={{(bem)}}
      type='button'
      {{on 'click' (fn @onSelect @contentItemType)}}
    >
      {{svgJar (modelIcon @contentItemType) class=(bem 'icon')}}
      {{this.contentItemTypeName}}
    </button>
  </template>
}
